import React from "react";
import { addYears, format, subYears } from "date-fns";
import { useCalendarData, calendarViews } from "../../utils";
import CalendarIcon from "../../../../svg/CalendarIcon/CalendarIcon";
import { Chevron } from "../../../../svg";
import { chevronDirection } from "../../../../svg/Svg";
import { useReactAppState } from "../../../../../shared/containers/utils";

function Years() {
  const {
    disablePreviousYears,
    disableNextYears,
    setView,
    setCurrentDate,
    currentDate,
    onTodaySelect,
    yearsData,
    onDateSelect,
  } = useCalendarData();

  const { t } = useReactAppState();
  const currentYear = format(currentDate, 'y');
  const { yearsRange, yearsLabel } = yearsData || {};

  return (
    <div className="mls-o-calendar__years-view">
      <div className="mls-o-calendar__header">
        <button type="button" className="mls-o-calendar__prev-month"
          disabled={disablePreviousYears}
          onClick={() => disablePreviousYears ? null : setCurrentDate(subYears(currentDate, 7))}>
          <Chevron direction={chevronDirection.left} />
        </button>
        <button type="button" onClick={() => setView(calendarViews.days)} className="mls-o-calendar__title">
          <CalendarIcon />
          <span className="mls-o-calendar__title-label">{yearsLabel}</span>
        </button>
        <button type="button" className="mls-o-calendar__next-month"
          disabled={disableNextYears}
          onClick={() => disableNextYears ? null : setCurrentDate(addYears(currentDate, 7))}>
          <Chevron direction={chevronDirection.right} />
        </button>
      </div>

      <div className="mls-o-calendar__month-grid">
        {
          yearsRange
            ? yearsRange.map(year => {
              const formattedYear = format(year, 'y');

              return <button onClick={(e) => onDateSelect(e, year)} className={`mls-o-calendar__year ${currentYear === formattedYear ? "mls-o-calendar__year--current-year" : ""}`} key={formattedYear}>{formattedYear}</button>;
            })
            : null
        }
      </div>
      <button onClick={onTodaySelect} className="mls-o-calendar__today">{t("today")}</button>
    </div>
  );
}

export default Years;
